import chalk1Svg from './assets/chalk-1.svg';
import chalk2Svg from './assets/chalk-2.svg';
import hog1Svg from './assets/hog-1.svg';
import hog2Svg from './assets/hog-2.svg';
import hog3Svg from './assets/hog-3.svg';
import layer1Svg from './assets/layer-1.svg';
import layer2Svg from './assets/layer-2.svg';
import presetsSvg from './assets/presets.svg';
import rag1Svg from './assets/rag-1.svg';
import rag2Svg from './assets/rag-2.svg';
import sobol1Svg from './assets/sobol-1.svg';
import sobol2Svg from './assets/sobol-2.svg';
import sobol3Svg from './assets/sobol-3.svg';

const icons = {
  'chalk-1': chalk1Svg,
  'chalk-2': chalk2Svg,
  'hog-1': hog1Svg,
  'hog-2': hog2Svg,
  'hog-3': hog3Svg,
  'rag-1': rag1Svg,
  'rag-2': rag2Svg,
  'sobol-1': sobol1Svg,
  'sobol-2': sobol2Svg,
  'sobol-3': sobol3Svg,
  'layer-1': layer1Svg,
  'layer-2': layer2Svg,
  custom: presetsSvg,
};

export default icons;
